import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  updateConfigurationValue,
  updateConfigurationValueYamlBased,
  resetYamlCodeValue,
  updateDownloadConciegeAlertStatus,
  updateAlertStatus,
} from '../../store/actions/onboarding';

import {
  conciergeDownloadLink,
  getFrameworkConfigurationYamlBased,
  getTestRunnerCmd,
  javaFrameworks,
  getShellOption,
} from '../../utils/onboarding/languageBasedConfig';
import {
  HYPERTEST_DEFAULT_RETRY,
  HYPERTEST_DEFAULT_CONCURRENCY,
  HYPERTEST_DEFAULT_TIMEOUT,
} from '../../utils/constant';
import { getHypertestConcurrency } from '../../store/actions/concurrency';
import { getFrameworkConfigurationYamlBasedLinux } from '../../utils/onboarding/languageBasedConfigLinux';
import { sendAmplitudeEvents } from '../../utils/common';
import { EventNames } from '../../utils/events';
const queryString = require('query-string');
const useOnboardingConfigurationYamlBased = (props) => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo?.userInfo);
  const concurrency = useSelector((state) => state.concurrency?.concurrency);
  const [textCopiedType, setTextCopiedType] = useState('');
  const currentConfiguration = useSelector(
    (state) => state.onboarding?.currentConfiguration
  );
  const currentConfigurationYamlBased = useSelector(
    (state) => state.onboarding?.currentConfigurationYamlBased
  );
  const visual = useSelector((state) => state.onboarding?.visual);
  let setting = useSelector((state) => state.appSetting?.setting);

  const [testRunnerCmdCopy, setTestRunnerCmdCopy] = useState(false);
  const [yamlCopied, setYamlCopied] = useState(false);
  const [yamlDownloaded, setYamlDownloaded] = useState(false);
  const [concurrencyInputFieldValue, setConcurrencyInputFieldValue] = useState(
    currentConfigurationYamlBased.concurrency
      ? currentConfigurationYamlBased.concurrency
      : HYPERTEST_DEFAULT_CONCURRENCY
  );
  const [retryInputFieldValue, setRetryInputFieldValue] = useState(
    currentConfigurationYamlBased.retry
      ? currentConfigurationYamlBased.retry
      : HYPERTEST_DEFAULT_RETRY
  );
  const [timeoutInputFieldValue, setTimeoutInputFieldValue] = useState(
    currentConfigurationYamlBased.timeout
      ? currentConfigurationYamlBased.timeout
      : HYPERTEST_DEFAULT_TIMEOUT
  );
  let parsed = queryString.parse(window.location.search);
  function setIsConciergeAvailable(isAvailable) {
    dispatch(updateConfigurationValue({ isConciergeAvialble: isAvailable }));
    let completedSteps = [
      ...currentConfigurationYamlBased.completedSteps,
      'concierge_cli_avilable',
    ];
    dispatch(
      updateConfigurationValueYamlBased({
        completedSteps: completedSteps,
      })
    );
  }
  const [activeEventKeyUserSetting, setActiveEventKeyUserSetting] =
    useState(null);
  const [activeEventKeyHypertestCli, setActiveEventKeyHypertestCli] =
    useState(0);
  const [activeEventKeyTimeout, setActiveEventKeyTimeout] = useState(null);
  const [activeEventKeyTestDiscovery, setActiveEventKeyTestDiscovery] =
    useState(null);
  const [activeEventKeyTestRunner, setActiveEventKeyTestRunner] =
    useState(null);
  const [activeEventKeyTestRunCmd, setActiveEventKeyTestRunCmd] =
    useState(null);
  const [activeEventKeyOS, setActiveEventKeyOS] = useState(null);
  
  function setActiveEventKeyAccordianUserSetting(key) {
    setActiveEventKeyUserSetting(key);
  }
  function setActiveEventKeyAccordianTimeout(key) {
    setActiveEventKeyTimeout(key);
  }
  function setActiveEventKeyAccordianOS(key) {
    setActiveEventKeyOS(key);
  }
  const [currentYamlOsSelection, setCurrentYamlOsSelection] = useState(0);
  let systemOS = 'win';
  if (window.navigator.platform.indexOf('Win') !== -1) {
    systemOS = 'win';
  } else if (window.navigator.platform.indexOf('Mac') !== -1) {
    systemOS = 'mac';
  } else if (window.navigator.platform.indexOf('Linux') !== -1) {
    systemOS = 'linux';
  }
  function getSystemOsName(osName) {
    let platformName = osName ? osName : systemOS;
    switch (platformName) {
      case 'win':
        return 'Windows';
      case 'mac':
        return 'MacOS';
      case 'linux':
        return 'Linux';
      default:
        return '';
    }
  }
  function getSystemOsIcon(osName) {
    let platformName = osName ? osName : systemOS;
    switch (platformName) {
      case 'win':
        return 'onboard/windows';
      case 'mac':
        return 'onboard/macos';
      case 'linux':
        return 'onboard/linux';
      default:
        return '';
    }
  }
  function getOthersOS() {
    switch (systemOS) {
      case 'win':
        return ['mac', 'linux'];
      case 'mac':
        return ['win', 'linux'];
      case 'linux':
        return ['win', 'mac'];
      default:
        return [];
    }
  }
  useEffect(() => {
    let platform = 'win';
    if (window.navigator.platform.indexOf('Win') !== -1) {
      platform = 'win';
    } else if (window.navigator.platform.indexOf('Mac') !== -1) {
      platform = 'mac';
    } else if (window.navigator.platform.indexOf('Linux') !== -1) {
      platform = 'linux';
    }
    dispatch(
      updateConfigurationValue({
        conciergePlatform: platform,
      })
    );
    dispatch(
      getHypertestConcurrency({
        auth: {
          username: userInfo.data && userInfo.data.username,
          password: userInfo.data && userInfo.data.apiToken,
        },
        orgId:
          userInfo.data &&
          userInfo.data.organization &&
          userInfo.data.organization.id,
      })
    );
    let urlSegments = window.location.pathname.split('/');
    dispatch(
      updateConfigurationValue({
        framework: {
          ...currentConfiguration.framework,
          name: urlSegments[urlSegments.length - 1],
        },
        frameworkType: parsed && parsed.frameworkType,
        testType: 'yamlBased',
      })
    );
    let langConfig = getFrameworkConfigurationYamlBased(
      urlSegments[urlSegments.length - 1],
      parsed && parsed.frameworkType
    );
    let testRunnerCmd = getTestRunnerCmd(
      platform,
      urlSegments[urlSegments.length - 1],
      parsed && parsed.frameworkType
    );
    let conccurrency = HYPERTEST_DEFAULT_CONCURRENCY;
    if (parsed && parsed.frameworkType === 'PlayWright') {
      conccurrency = 2;
    }
    dispatch(
      updateConfigurationValueYamlBased({
        frameworkConfiguration: langConfig,
        testRunner: testRunnerCmd ? testRunnerCmd : langConfig?.testRunnerCmd,
        testdiscovery: langConfig?.testDiscoveryCmd,
        concurrency: conccurrency,
      })
    );

    return function () {
      dispatch(updateDownloadConciegeAlertStatus(false));
      updateYamlCopyAlertStatus({
        yamlCodeCopiedAlert: false,
        yamlCodeDownloadedAlert: false,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getYamlCode() {
    let currentFrameWorkName =
      currentConfiguration &&
      currentConfiguration.framework &&
      currentConfiguration.framework.name;
    let yamlCode = getFrameworkConfigurationYamlBased(
      currentFrameWorkName,
      currentConfiguration.frameworkType
    ).yamlCode;
    if (currentConfiguration.platform === 'linux') {
      yamlCode = getFrameworkConfigurationYamlBasedLinux(
        currentFrameWorkName,
        currentConfiguration.frameworkType
      ).yamlCode;
    }
    let shellOption = getShellOption(
      currentConfiguration.platform,
      currentFrameWorkName
    );
    let retryOnFailure =
      parseInt(currentConfigurationYamlBased.retry) === 0 ||
      retryInputFieldValue === 0
        ? false
        : true;
    let testRunnerCmd = getTestRunnerCmd(
      currentConfiguration.platform,
      currentFrameWorkName,
      currentConfiguration.frameworkType
    );
    let mapObj = {
      PLATFORM: currentConfiguration.platform,
      CONCURRENCY: currentConfigurationYamlBased.concurrency,
      RETRIES: currentConfigurationYamlBased.retry,
      TIMEOUT: currentConfigurationYamlBased.timeout,
      TEST_DISCOVERY: currentConfigurationYamlBased.testdiscovery,
      TEST_RUNNER: testRunnerCmd
        ? testRunnerCmd
        : currentConfigurationYamlBased.testRunner,
      SHELL_OPTION: shellOption,
      RETRYONFAILURE: retryOnFailure,
    };
    yamlCode = yamlCode.replace(
      /PLATFORM|CONCURRENCY|RETRIES|TIMEOUT|TEST_DISCOVERY|TEST_RUNNER|SHELL_OPTION|RETRYONFAILURE/g,
      function (matched) {
        return mapObj[matched];
      }
    );
    return yamlCode;
  }
  function updateYaml(yamlCode) {
    dispatch(
      updateConfigurationValueYamlBased({
        frameworkConfiguration: {
          ...currentConfiguration.frameworkConfiguration,
          yamlCode: yamlCode,
        },
      })
    );
  }
  function resetYamlCode() {
    let platform = 'win';
    if (window.navigator.platform.indexOf('Win') !== -1) {
      platform = 'win';
    } else if (window.navigator.platform.indexOf('Mac') !== -1) {
      platform = 'mac';
    } else if (window.navigator.platform.indexOf('Linux') !== -1) {
      platform = 'linux';
    }
    dispatch(
      updateConfigurationValue({
        conciergePlatform: platform,
        frameworkType: parsed && parsed.frameworkType,
      })
    );
    let urlSegments = window.location.pathname.split('/');
    let langConfig = getFrameworkConfigurationYamlBased(
      urlSegments[urlSegments.length - 1],
      parsed && parsed.frameworkType
    );
    let testRunnerCmd = getTestRunnerCmd(
      platform,
      urlSegments[urlSegments.length - 1],
      parsed && parsed.frameworkType
    );
    dispatch(
      updateConfigurationValueYamlBased({
        frameworkConfiguration: langConfig,
        testRunner: testRunnerCmd ? testRunnerCmd : langConfig.testRunnerCmd,
        testdiscovery: langConfig.testDiscoveryCmd,
      })
    );
    dispatch(resetYamlCodeValue());
  }
  function copyBtnClicked(type) {
    setTextCopiedType(type);
    setTimeout(() => {
      setTextCopiedType('');
    }, 1000);
    if (type === 'yaml') {
      setYamlCopied(true);
      setYamlDownloaded(false);
      dispatch(updateDownloadConciegeAlertStatus(false));
      updateYamlCopyAlertStatus({
        yamlCodeCopiedAlert: true,
        yamlCodeDownloadedAlert: false,
      });
    }
  }
  function downloadYaml(text) {
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';

    var json = text;
    var blob = new Blob([json], { type: 'octet/stream' });
    var url = window.URL.createObjectURL(blob);
    //window.location.assign(url);
    a.href = url;
    a.download = 'hyperexecute.yaml';
    a.click();
    window.URL.revokeObjectURL(url);
    setYamlCopied(false);
    setYamlDownloaded(true);
    dispatch(updateDownloadConciegeAlertStatus(false));
    updateYamlCopyAlertStatus({
      yamlCodeDownloadedAlert: true,
      yamlCodeCopiedAlert: false,
    });
  }
  function setPlatform(type) {
    let completedSteps = [
      ...currentConfigurationYamlBased.completedSteps,
      'platform_changed',
    ];
    dispatch(
      updateConfigurationValue({
        platform: type,
      })
    );
    dispatch(
      updateConfigurationValueYamlBased({
        completedSteps: completedSteps,
      })
    );
    let currentFrameWorkName =
      currentConfiguration &&
      currentConfiguration.framework &&
      currentConfiguration.framework.name;
    if (javaFrameworks.indexOf(currentFrameWorkName) !== -1) {
      let testRunnerCmd = getTestRunnerCmd(
        type,
        currentFrameWorkName,
        currentConfiguration.frameworkType
      );
      dispatch(
        updateConfigurationValueYamlBased({
          testRunner: testRunnerCmd,
        })
      );
    }
    sendAmplitudeEvents(EventNames.HYP_ONBOARDING_OS_SELECTION_YAML, {
      os: type,
    });
  }
  function setConciergePlatform(type) {
    dispatch(
      updateConfigurationValue({
        conciergePlatform: type,
      })
    );
  }
  function changeConcurrency(concValue, type) {
    let allowedConcurrency =
      concurrency &&
      concurrency.data &&
      concurrency.data.data &&
      concurrency.data.data.total;
    let updatedConcurrency = concValue;
    if (type === 'slider') {
      updatedConcurrency = concValue;
    } else {
      updatedConcurrency = concValue.target.value;
    }
    setConcurrencyInputFieldValue(updatedConcurrency);
    if (
      !(
        updatedConcurrency > allowedConcurrency ||
        updatedConcurrency < 1 ||
        updatedConcurrency === ''
      )
    ) {
      let completedSteps = [
        ...currentConfigurationYamlBased.completedSteps,
        'concurrency_changed',
      ];
      dispatch(
        updateConfigurationValueYamlBased({
          concurrency: updatedConcurrency,
          completedSteps: completedSteps,
        })
      );
    }
  }
  function changeRetry(retryValue, type) {
    let allowedMaxRetry = 5;
    let updatedRetry = retryValue;
    if (type === 'slider') {
      updatedRetry = retryValue;
    } else {
      updatedRetry = retryValue.target.value;
    }
    setRetryInputFieldValue(updatedRetry);
    if (
      !(
        updatedRetry > allowedMaxRetry ||
        updatedRetry < 0 ||
        updatedRetry === ''
      )
    ) {
      let completedSteps = [
        ...currentConfigurationYamlBased.completedSteps,
        'retry_changed',
      ];
      dispatch(
        updateConfigurationValueYamlBased({
          retry: updatedRetry,
          completedSteps: completedSteps,
        })
      );
    }
  }
  function changeTimeout(timeoutValue, type) {
    let allowedMaxTimeout = 150;
    let updatedTimeout = timeoutValue;
    if (type === 'slider') {
      updatedTimeout = timeoutValue;
    } else {
      updatedTimeout = timeoutValue.target.value;
    }
    setTimeoutInputFieldValue(updatedTimeout);
    if (
      !(
        updatedTimeout > allowedMaxTimeout ||
        updatedTimeout < 5 ||
        updatedTimeout === ''
      )
    ) {
      let completedSteps = [
        ...currentConfigurationYamlBased.completedSteps,
        'timeout_changed',
      ];
      dispatch(
        updateConfigurationValueYamlBased({
          timeout: updatedTimeout,
          completedSteps: completedSteps,
        })
      );
    }
  }
  function updateTestDiscovery(value) {
    let completedSteps = [
      ...currentConfigurationYamlBased.completedSteps,
      'test_discovery_changed',
    ];
    dispatch(
      updateConfigurationValueYamlBased({
        testdiscovery: value,
        completedSteps: completedSteps,
        currentStep: 5,
      })
    );
  }
  function updateTestRunner(value) {
    let completedSteps = [
      ...currentConfigurationYamlBased.completedSteps,
      'test_runner_changed',
    ];
    dispatch(
      updateConfigurationValueYamlBased({
        testRunner: value,
        completedSteps: completedSteps,
        currentStep: 6,
      })
    );
  }
  function getCommandToRunTest() {
    let conciergeBasedOnOs = './hyperexecute';
    switch (currentConfiguration.conciergePlatform) {
      case 'win':
        conciergeBasedOnOs = 'hyperexecute.exe';
        break;
      case 'mac':
      case 'linux':
        conciergeBasedOnOs = './hyperexecute';
        break;
      default:
        break;
    }
    let command =
      currentConfigurationYamlBased &&
      currentConfigurationYamlBased.frameworkConfiguration &&
      currentConfigurationYamlBased.frameworkConfiguration.runTestCommand;
    let config = '<your_yaml_file_name>';
    if (yamlDownloaded) {
      config = 'hyperexecute.yaml';
    }
    let mapObj = {
      USERNAME: userInfo && userInfo.data && userInfo.data.username,
      ACCESSKEY: userInfo && userInfo.data && userInfo.data.apiToken,
      CONCIERGE: conciergeBasedOnOs,
      CONFIG: config,
    };
    if (command) {
      command = command.replace(
        /USERNAME|ACCESSKEY|CONCIERGE|CONFIG/g,
        function (matched) {
          return mapObj[matched];
        }
      );
    }
    return command;
  }
  function downloadConcierge(type) {
    // let conciergeUrl = '';
    // if (type === 'mac') {
    //   conciergeUrl = conciergeDownloadLink.mac;
    // } else if (type === 'linux') {
    //   conciergeUrl = conciergeDownloadLink.linux;
    // } else if (type === 'win') {
    //   conciergeUrl = conciergeDownloadLink.windows;
    // }
    // if (conciergeUrl) {
    //   window.open(conciergeUrl, '_blank');
    // }
    setConciergePlatform(type);
    let completedSteps = [
      ...currentConfigurationYamlBased.completedSteps,
      'download_concierge',
    ];
    dispatch(
      updateConfigurationValueYamlBased({
        completedSteps: completedSteps,
        currentStep: 2,
      })
    );
    setActiveEventKeyHypertestCli(null);
    if (type !== 'win' && type !== '') {
      dispatch(updateDownloadConciegeAlertStatus(true));
      updateYamlCopyAlertStatus({
        yamlCodeDownloadedAlert: false,
        yamlCodeCopiedAlert: false,
      });
    } else {
      // for window , downt show popup
      dispatch(updateDownloadConciegeAlertStatus(false));
    }
    sendAmplitudeEvents(
      EventNames.HYP_ONBOARDING_HYPEREXECUTE_CLI_DOWNLOAD_YAML,
      {
        os: type,
      }
    );
  }
  function platformChange(index) {
    setCurrentYamlOsSelection(index);
    let os = 'win';
    if (index === 0) {
      os = 'win';
    } else if (index === 1) {
      os = 'linux';
    }
    setPlatform(os);
  }
  function copyBtnClickedTestRunner() {
    setTestRunnerCmdCopy(true);
    setTimeout(() => {
      setTestRunnerCmdCopy(false);
    }, 1000);
  }
  function resetDownloadCociergeAlert() {
    dispatch(updateDownloadConciegeAlertStatus(false));
  }
  function getConciergeURL(type) {
    let conciergeUrl = '';
    if (type === 'mac') {
      conciergeUrl = conciergeDownloadLink.mac;
    } else if (type === 'linux') {
      conciergeUrl = conciergeDownloadLink.linux;
    } else if (type === 'win') {
      conciergeUrl = conciergeDownloadLink.windows;
    }
    return conciergeUrl;
  }
  function updateYamlCopyAlertStatus(status) {
    dispatch(updateAlertStatus(status));
  }
  function updateCompletedSteps(completedStep, currentStep) {
    let completedSteps = [
      ...currentConfigurationYamlBased.completedSteps,
      ...completedStep,
    ];
    dispatch(
      updateConfigurationValueYamlBased({
        currentStep: currentStep,
        completedSteps: completedSteps,
      })
    );
    closeCurrentStepAndOpenNext(currentStep);
  }
  function closeCurrentStepAndOpenNext(nextStep) {
    switch (nextStep) {
      case 2:
        setActiveEventKeyHypertestCli(null);
        setActiveEventKeyUserSetting(0);
        break;
      case 3:
        setActiveEventKeyUserSetting(null);
        setActiveEventKeyTimeout(0);
        break;
      case 4:
        setActiveEventKeyTimeout(null);
        setActiveEventKeyTestDiscovery(0);
        break;
      case 5:
        setActiveEventKeyTestDiscovery(null);
        setActiveEventKeyTestRunner(0);
        break;
      case 6:
        setActiveEventKeyTestRunner(null);
        setActiveEventKeyTestRunCmd(0);
        break;
      default:
        break;
    }
  }
  return {
    userInfo,
    currentConfiguration,
    setIsConciergeAvailable,
    currentConfigurationYamlBased,
    setActiveEventKeyAccordianUserSetting,
    setActiveEventKeyAccordianTimeout,
    setActiveEventKeyAccordianOS,
    activeEventKeyOS,
    activeEventKeyTimeout,
    activeEventKeyUserSetting,
    activeEventKeyHypertestCli,
    setActiveEventKeyHypertestCli,
    activeEventKeyTestDiscovery,
    setActiveEventKeyTestDiscovery,
    activeEventKeyTestRunner,
    setActiveEventKeyTestRunner,
    activeEventKeyTestRunCmd,
    setActiveEventKeyTestRunCmd,
    updateYaml,
    getYamlCode,
    textCopiedType,
    copyBtnClicked,
    downloadYaml,
    setPlatform,
    changeConcurrency,
    changeRetry,
    changeTimeout,
    updateTestDiscovery,
    updateTestRunner,
    getCommandToRunTest,
    downloadConcierge,
    resetYamlCode,
    setConciergePlatform,
    concurrency,
    systemOS,
    getSystemOsIcon,
    getSystemOsName,
    getOthersOS,
    currentYamlOsSelection,
    platformChange,
    testRunnerCmdCopy,
    copyBtnClickedTestRunner,
    concurrencyInputFieldValue,
    retryInputFieldValue,
    timeoutInputFieldValue,
    visual,
    resetDownloadCociergeAlert,
    getConciergeURL,
    yamlCopied,
    yamlDownloaded,
    updateYamlCopyAlertStatus,
    updateCompletedSteps,
    promoBannerHeight: setting.promoBannerHeight,
  };
};

export default useOnboardingConfigurationYamlBased;
